var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"label":"Validation","rules":_vm.rules,"value":_vm.value,"rows":"2"}})}
var staticRenderFns = []

export { render, staticRenderFns }